import { toastService } from "../../../component/common/toast-messages/toast";
import Actions from "../../actions";
import * as requestFromServer from "./paymentApis";

// get all user cards from server
export const getAllCardsAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getAllCards();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_ALL_USER_CARDS, response));
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// get all user cards from server
export const getTaxonomyAction = (setLoading) => async (dispatch) => {
  setLoading(true);
  const response = await requestFromServer.getTaxDetails();
  if (response) {
    dispatch(Actions.createAction(Actions.GET_TAX_DETAILS, response));
    setLoading(false);
    return response;
  } else {
    setLoading(false);
    return null;
  }
};

// api -> create payment intent
export const createPaymentIntent =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.createPaymentIntent(dataToBeSent);
    if (response) {
      dispatch(Actions.createAction(Actions.PAYMENT_INTENT_DATA, response));
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> get payment intent
export const getPaymentIntentAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getPaymentIntent(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> create payment intent
export const createSubscriptionPurchase =
  (
    dataToBeSent,
    setLoading,
    setOpenPaymentConfirmationDialog,
    resetDefaultFields
  ) =>
  async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.purchasePlan(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_COUPON, {
          validateCouponData: {},
        })
      );
      setOpenPaymentConfirmationDialog(true);
      resetDefaultFields();
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> create push notification
export const purchasePushNotificationAction =
  (
    dataToBeSent,
    setLoading,
    setOpenPaymentConfirmationDialog,
    resetDefaultFields
  ) =>
  async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.purchasePushNotification(
      dataToBeSent
    );
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.CLEAR_PAYMENT_INTENT_DATA));
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_COUPON, {
          validateCouponData: {},
        })
      );
      setOpenPaymentConfirmationDialog(true);
      resetDefaultFields();
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// api -> validate coupon code
export const validateCouponCodeAction =
  (dataToBeSent, setLoading, setCouponCodeMessage) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.validateCouponCode(dataToBeSent);
    if (response) {
      if (response?.is_valid) {
        toastService.success(response?.message);
        setCouponCodeMessage(response?.message);
      } else {
        toastService.error(response?.message);
      }
      dispatch(
        Actions.createAction(Actions.GET_VALIDATE_COUPON, {
          validateCouponData: response,
        })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
